import _ from "underscore";
import AsnStore from "../../../stores/AsnStore";
import stores from "../../../stores";
import C from "../constants";
const {QUOTES_RELATED_SNAPSHOT} = C;

let singleton;

export default function asnQuoteSnapshotWatcherFactory(options){
  if(singleton){
    singleton.setOptions(options);
    return singleton;
  }
  else{
    singleton = new AsnQuoteSnapshotWatcher(options);
    singleton.init();
    return singleton;
  }
}

function AsnQuoteSnapshotWatcher(options){
  const self = this;
  const opts = {};
  setOptions(options);

  const storesSnapshotConfig = [
    {
      storeName: "AsnStore"
    },
    {
      storeName: "AsnDetailStore"
    }
  ];

  self.setOptions = setOptions;

  function setOptions(options={}){
    _.extend(opts, options);
  }

  self.init = function(){
    bindStores();
  }


  function bindStores(){
    AsnStore.bindListener("asns:fetchingQuotes", onFetchingStarted);
  }

  function onFetchingStarted(){
    generateSnapshots();
  }


  self.generateSnapshots = generateSnapshots;
  // This is the public function
  // to handle the entire lifecycle
  // of removing existing snapshots,
  // and creating a new snapshot
  function generateSnapshots(){
    // asn = getCurrentAsn();
    removeExistingSnapshots();
    createSnapshots();
    // logAllSnapshots();
  }


  self.generateInitialSnapshotsOnLoad = generateInitialSnapshotsOnLoad;
  // this function is a smart generator
  // for snapshots based on whether 
  // quotes exist on load or not.
  // It should be called ONCE in the main
  // loaded file for the given page 
  // at the very end (asnWizard.js)
  function generateInitialSnapshotsOnLoad(){
    const asn = getCurrentAsn();
    if(hasQuotesForAsn(asn) || hasSpecialQuote(asn)){
      // console.log("generating initial snapshots for quote related stores...");
      generateSnapshots();
    }
  }


  function removeExistingSnapshots(){
    _(storesSnapshotConfig).map(removeExistingSnapshotForStoreName);
  }

  function removeExistingSnapshotForStoreName({storeName}){
    stores[storeName].removeDataSnapshotViaTag(QUOTES_RELATED_SNAPSHOT);
  }

  function createSnapshots(){
   _(storesSnapshotConfig).map(createSnapshotForStoreName);
  }

  function createSnapshotForStoreName({storeName}){
    stores[storeName].createDataSnapshot(QUOTES_RELATED_SNAPSHOT);
  }

  // function logAllSnapshots(){
  //   _(storesSnapshotConfig).map(({storeName})=>{
  //     console.log(`${storeName} snapshots:`);
  //     console.log(stores[storeName].getDataSnapshots());
  //   });
  // }
  function hasQuotesForAsn(asn){
    const q = AsnStore.getAvailableAndSelectedQuotesForAsn(asn);
    return q && q.length;
  }

    function hasSpecialQuote(asn){
    return AsnStore.hasSpecialQuote(asn);
  }

  function getCurrentAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/businessLogic/asnQuoteSnapshotWatcherFactory.js